import type { ReactNode } from "react";

export function Eyebrow({ children }: { readonly children: ReactNode }) {
  return <div className="cx-eyebrow">{children}</div>;
}

export function Muted({ children, small }: { readonly children: ReactNode; readonly small?: boolean }) {
  return <span className={small === true ? "cx-muted cx-sm" : "cx-muted"}>{children}</span>;
}

export function Mono({ children }: { readonly children: ReactNode }) {
  return <span className="cx-mono">{children}</span>;
}

export function Dot({ tone }: { readonly tone: "live" | "warn" | "wait" | "off" }) {
  return <span className={`cx-dot cx-dot-${tone}`} />;
}

export function Facts({
  items,
}: {
  readonly items: readonly { label: string; value: ReactNode; mono?: boolean }[];
}) {
  return (
    <dl className="cx-facts">
      {items.map((item) => (
        <div key={item.label} style={{ display: "contents" }}>
          <dt>{item.label}</dt>
          <dd className={item.mono === true ? "cx-mono" : undefined}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
